import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { setupApplication, store } from './store/store';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

setupApplication()
    .then(() => console.log('The application was successfully setup'))
    .finally(() => {
        root.render(
          <Provider store={store}>
            <React.StrictMode>
              <App />
            </React.StrictMode>
          </Provider>
        );
    });

reportWebVitals();
